import { useEffect, useState } from "react";
import { Gift, EnvelopeSimple } from "@phosphor-icons/react";
import client from "../lib/api";

const OUTCOME_PILLS = {
  referred: "border-emerald-500/40 bg-emerald-500/10 text-emerald-300",
  clicked: "border-sky-500/40 bg-sky-500/10 text-sky-300",
  no_action: "border-white/10 bg-white/[0.04] text-neutral-500",
};

function outcomeLabel(r) {
  if (r.outcome === "referred") return `sent ${r.referrals_after_ask} referral${r.referrals_after_ask === 1 ? "" : "s"}`;
  if (r.outcome === "clicked") return `link visited ${r.visits_after_ask}× · no signup yet`;
  return r.has_account ? "no action yet" : "no account linked";
}

export const ReferralThanksCard = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    client.get("/admin/referral-ask-outcomes").then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data || !data.count) return null;

  const thanksMailto = (r) => {
    const first = (r.contact_name || "").split(" ")[0] || "there";
    const subject = encodeURIComponent("You're the reason we're growing — thank you");
    const body = encodeURIComponent(
      `${first},\n\nJust saw someone you sent our way signed up. That means a lot — referrals from real operators like you are how FreightPilot grows.\n\nYour next month is on me. If there's anything you need, reply here and it jumps the queue.\n\nMike\nFreightPilot AI`
    );
    return `mailto:${r.email}?subject=${subject}&body=${body}`;
  };

  return (
    <div className="mt-6 card-surface p-4" data-testid="referral-thanks-card">
      <div className="flex items-center justify-between mb-3 flex-wrap gap-2">
        <div className="flex items-center gap-2">
          <Gift size={14} weight="bold" color="#34d399" />
          <span className="overline">REFERRAL THANK-YOU TRACKER · AFTER 30-DAY ASK</span>
        </div>
        <span className="text-[10px] text-neutral-500 font-mono" data-testid="referral-thanks-summary">
          {data.count} asked · <span className="text-emerald-300">{data.referred} referred</span> · <span className="text-sky-300">{data.clicked} clicked</span>
        </span>
      </div>
      <div className="space-y-2">
        {data.rows.map((r) => (
          <div
            key={r.lead_id}
            data-testid={`referral-outcome-row-${r.lead_id}`}
            className="flex items-center gap-3 flex-wrap rounded-md border border-white/[0.06] bg-white/[0.02] px-3 py-2"
          >
            <div className="min-w-0 flex-1">
              <div className="text-xs font-medium text-neutral-200 truncate">
                {r.company_name || r.contact_name || r.email}
              </div>
              <div className="text-[10px] text-neutral-500 font-mono">
                asked {String(r.asked_at).slice(0, 10)}
                {r.referred.length > 0 && (
                  <span className="text-emerald-400/80"> → {r.referred.map((x) => x.email).join(", ")}</span>
                )}
              </div>
            </div>
            <span className={`rounded-full border px-2.5 py-0.5 text-[10px] font-semibold ${OUTCOME_PILLS[r.outcome]}`}>
              {outcomeLabel(r)}
            </span>
            {r.outcome === "referred" && (
              <a
                href={thanksMailto(r)}
                data-testid={`referral-say-thanks-${r.lead_id}`}
                className="inline-flex items-center gap-1 rounded-full border border-emerald-500/40 px-2.5 py-1 text-[10px] font-semibold text-emerald-300 hover:bg-emerald-500/10 transition-colors"
              >
                <EnvelopeSimple size={11} weight="bold" /> Say thanks
              </a>
            )}
          </div>
        ))}
      </div>
      <div className="text-[10px] text-neutral-500 mt-3">
        Tracks each won customer's referral link activity after their 30-day ask email — thank the ones who delivered.
      </div>
    </div>
  );
};
